import { useEffect, useRef, useState } from 'react';
import Actions from '@redux/payments';
import { NonRKPayInvoiceService } from '../../../../../services';

/**
 * Based on filters passed, get the list of invoices from the server. Returns data, isLoading and error on an array.
 * Skiping new requests when the new filters are the same as the previous ones.
 * @property {Object} filters
 * @returns {Array} [data, isLoading, error]
 * @example
 * const [data, isLoading, error] = useGetNonRKPayInvoiceList(filters);
*/
const useGetNonRKPayInvoiceList = (dispatch, filters, counts) => {
	const [data, setData] = useState({
		ItemList : [],
	});
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(null);
	const previousFilters = useRef();

	useEffect(() => {
		if (JSON.stringify(filters) !== JSON.stringify(previousFilters.current)) {
			previousFilters.current = filters;
			setIsLoading(true);
			dispatch(Actions.setLoading('counts', true));
			NonRKPayInvoiceService.getInvoiceList({
				...filters,
				paid      : false,
				finalized : true,
			}).then((res) => {
				if (res.data.ItemList) {
					const countsObj = {
						review  : counts.review,
						payment : res.data.Total,
						dispute : counts.dispute,
						balance : counts.balance,
					};
					dispatch(Actions.updateStoreProperties({ counts : countsObj }));

					// Receive data
					dispatch(Actions.receiveData([{ property : 'counts', value : countsObj }]));
				}
				setData(res.data);
			}).catch((err) => {
				setError(err);
			}).finally(() => {
				setIsLoading(false);
				dispatch(Actions.setLoading('counts', false));
			});
		}
	}, [filters]);

	return [data, isLoading, error];
};

export default useGetNonRKPayInvoiceList;
